import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type {
  AssignmentScan,
  AssignmentScanFilters,
} from '../types/assignment-scan.types';

export const ASSIGNMENT_SCANS_QUERY_KEY = 'assignment_scans';

export interface PaginatedAssignmentScans {
  scans: AssignmentScan[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

/**
 * Хук для получения списка сканирований назначений с фильтрацией и пагинацией
 */
export const useAssignmentScans = (filters: AssignmentScanFilters = {}) => {
  return useQuery({
    queryKey: [ASSIGNMENT_SCANS_QUERY_KEY, 'scans', filters],
    queryFn: async (): Promise<PaginatedAssignmentScans> => {
      const response: any = await apiClient.getAssignmentScans(filters);

      return {
        scans: response.scans || [],
        total: response.pagination?.total_items || 0,
        page: response.pagination?.page || 1,
        pageSize: response.pagination?.page_size || 20,
        totalPages: response.pagination?.total_pages || 1,
        hasNext: response.pagination?.has_next || false,
        hasPrevious: response.pagination?.has_previous || false,
      };
    },
    staleTime: 30 * 1000,
    retry: 3,
  });
};
